import Vue from 'vue'
import VueI18n from 'vue-i18n';
import vuetify from './plugins/vuetify'
import App from './App'

Vue.use(VueI18n);

const translations = require('./assets/translations');

export const languages = translations.languages;

const i18n = new VueI18n({
    locale: 'en',
    messages: translations,
});

new Vue({
    vuetify,
    i18n: i18n,
    components: {App},
    template: '<App/>',
    render: function (h) {return h(App)}
}).$mount('#app');

export function setLanguage(lang) {
    i18n.locale = lang.toLowerCase();
}

export function getLanguage() {
    return i18n.locale;
}
